// extracted by mini-css-extract-plugin
export default {"dotcomHeader":"dotcomHeader__CqlHa","mobile":"mobile__3tITk"};